import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-input hide-mobile" }, null, -1)
const _hoisted_3 = { class: "action-buttons flex-md-row flex-column sm-pdr-0 sm-pdl-0" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: "By completing the information below, a request will be sent to the Fund’s Administrative team for processing.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    _createVNode(_component_AlertsComponent, { errors: _ctx.generalErrors }, null, 8, ["errors"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            id: "pension-estimate-request-form",
            class: "form",
            method: "POST",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitData && _ctx.submitData(...args)), ["prevent"]))
          }, [
            _createVNode(_component_SelectComponent, {
              label: "Request Type",
              selectedOption: _ctx.formData.type,
              "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.type) = $event)),
              options: _ctx.requestTypes,
              singleArrow: true,
              readonly: true
            }, null, 8, ["selectedOption", "options"]),
            _createVNode(_component_TextInput, {
              type: "text",
              label: "Participant ID",
              placeholder: "Enter Participant ID",
              max: 25,
              modelValue: _ctx.formData.participant_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.participant_id) = $event)),
              readonly: true
            }, null, 8, ["modelValue"]),
            _hoisted_2,
            _createVNode(_component_TextInput, {
              type: "text",
              label: "First Name",
              placeholder: "Enter First Name",
              max: 12,
              modelValue: _ctx.formData.first_name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.first_name) = $event)),
              readonly: true
            }, null, 8, ["modelValue"]),
            _createVNode(_component_TextInput, {
              type: "text",
              label: "Last Name",
              placeholder: "Enter Last Name",
              max: 25,
              modelValue: _ctx.formData.last_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.last_name) = $event)),
              readonly: true
            }, null, 8, ["modelValue"]),
            _createVNode(_component_DateInput, {
              label: "DOB",
              modelValue: _ctx.formData.date_of_birth,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.date_of_birth) = $event)),
              readonly: true
            }, null, 8, ["modelValue"]),
            _createVNode(_component_DateInput, {
              reset: _ctx.reset,
              "onUpdate:reset": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reset) = $event)),
              label: "Anticipated Retirement Date",
              modelValue: _ctx.formData.retirement_date,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.retirement_date) = $event)),
              icon: false,
              "future-allow": true,
              "past-allow": false,
              "is-required": true,
              error: _ctx.errors.retirement_date,
              "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.errors.retirement_date) = $event))
            }, null, 8, ["reset", "modelValue", "error"]),
            _createVNode(_component_Textarea, {
              label: "Notes",
              message: "Notes field accepts up to 500 characters",
              modelValue: _ctx.formData.notes,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.notes) = $event)),
              max: 500
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetModal && _ctx.resetModal(...args)), ["prevent"])),
                class: "btn btn-secondary",
                disabled: _ctx.loadingSubmit
              }, " Discard ", 8, _hoisted_4),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                disabled: _ctx.loadingSubmit
              }, _toDisplayString(_ctx.loadingSubmit ? 'Submitting...' : 'Submit'), 9, _hoisted_5)
            ])
          ], 32)
        ]))
  ], 64))
}